import { useOnceInView } from '../useOnceInView';
import Trusted from './Trusted';
import css from './index.module.scss';
import { useLang } from '@/i18n';

function TheComp() {
    const { t } = useLang('theProduct');

    const list1 = [
        'https://websiteoss.ecoflow.com/figma-uploads/1767593479261-4v8jl8-compressed-tag.png',
        'https://websiteoss.ecoflow.com/figma-uploads/1767593483968-829c4t-compressed-tag.png',
        'https://websiteoss.ecoflow.com/figma-uploads/1767593488093-mvgdu0-compressed-tag.png',
        'https://websiteoss.ecoflow.com/figma-uploads/1767593491458-044ads-compressed-tag.png',
        'https://websiteoss.ecoflow.com/figma-uploads/1767593495261-3my5zi-compressed-tag.png',
    ];
    const list2 = [
        'https://websiteoss.ecoflow.com/figma-uploads/1767593534474-9f4dqv-compressed-tag.png',
        'https://websiteoss.ecoflow.com/figma-uploads/1767593541823-xo38l1-compressed-About%20%E2%80%93%20Campervan%20HQ.png',
        'https://websiteoss.ecoflow.com/figma-uploads/1767593546573-d1wpct-compressed-tag.png',
        'https://websiteoss.ecoflow.com/figma-uploads/1767593550353-m4gu7b-compressed-tag.png',
        'https://websiteoss.ecoflow.com/figma-uploads/1767593553656-i4mcsk-compressed-tag.png',
    ];

    useOnceInView('.on-the-road-J .J-title', () => {
        document.querySelector('.J-title')?.classList.add('enter');
        document.querySelector('.J-desc')?.classList.add('enter');
        document.querySelector('.J-Trusted-1')?.classList.add('enter');
        document.querySelector('.J-Trusted-2')?.classList.add('enter');
    });

    return (
        <section
            className={`${css.section} on-the-road-J GtmModuleData-section`}
            id="on-the-road-J"
            data-section-id={'on-the-road-J'}
            data-section-title={t('J_title')}
        >
            <div className="J-title ani-1">{t('J_title')}</div>
            <div className="J-desc ani-2">{t('J_desc')}</div>
            <Trusted className="J-Trusted-1 ani-3" title={t('J_trusted1_title')} list={list1} />
            <Trusted className="J-Trusted-2 ani-4" title={t('J_trusted2_title')} list={list2} />
        </section>
    );
}

export default TheComp;
